import { render } from "./TableCol.vue?vue&type=template&id=55838e25"
import script from "./TableCol.vue?vue&type=script&lang=js"
export * from "./TableCol.vue?vue&type=script&lang=js"
script.render = render

export default script